module.exports = __webpack_public_path__ + "static/favicon-192-f91504f7cb82c1b43599d61acb7fc90f.png";